/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/controls/modalContextController.ts" />

module Meevo.Plugins.Client {
    class ImageViewerController extends Meevo.Components.Controls.ModalContextController{

        static $inject = ["meevo.AppSettings", "$mdDialog", "context"];//"$scope"
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $mdDialog: angular.material.IDialogService,
            //protected $scope: angular.IScope,
            protected context: any
        ) {
            super(null, $mdDialog);
        }

        editFile() {
            this.context.edit();
            this.$mdDialog.cancel();
            
        }
    }



angular.module("meevo.plugins.client")
        .controller("meevo.plugins.client.ImageViewerController", ImageViewerController)
}